import { createFileRoute } from '@tanstack/react-router'
import { requireCapability } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { AuditPage } from '@/features/audit/audit-page'

export const Route = createFileRoute('/_dashboard/audit')({
  beforeLoad: requireCapability('VIEW_AUDIT'),
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: AuditPage,
})
